import PropTypes from 'prop-types';
import React, {useState} from "react";
import Select from 'react-select';

class FederatedSortMenu extends React.Component {
	constructor(props) {
		super(props);
    	this.onSelect = this.onSelect.bind(this);
		this.options = [];
	}

	onSelect({value}) {
	// 	debugger
	//   this.setState({sort: event.target.value});

	  	const sortField = value;
		const result = this.props.sortFields.find( ( { field } ) => field === sortField );

		// let order = result.order ?result.order : "desc"
		// this.setState({
		// 	sort: sortField,
		// 	order: order
		// },()=>{
			this.props.onChange(result.field, result.order);
		// })
	}

	componentDidMount() {
		// call api or anything
		console.log("Component has been rendered");
	}

	// componentDidUpdate(prevProps, prevState){
	// 	if (this.props.defaultSort !== prevProps.defaultSort){
	// 		this.setState({sort: this.props.defaultSort} )
	// 	}
	//}
	onTestChange(option) {
		console.log(option)
	}

	render() {
		const { sortFields } = this.props;
		if (sortFields.length === 0) { return null; }
		const result = this.props.sortFields.find( ( { value } ) => !!value );

		sortFields.map((sortField) => {
			const { field, label } = sortField
			const result = this.options.find((option) => option.value === field);
			if(!result) {
				this.options.push({
					value: field,
					label: label
				})
			}
		})

		const customDropdownStyles = {
			control: styles => ({ 
				...styles, 
				backgroundColor: '#fff',
				borderColor: '#6D6D6D',
				fontSize: '1rem',
				borderRadius: '0.25rem',
				padding: '0.5rem'
			}),
			container: styles => ({
				...styles, 
				minWidth: "11.75rem",
				"&:focus-visible": {
					border: "0.125rem solid #553178",
					outline: 'none'
				},
				"@media only screen and (max-width: 768px)": {
					...styles["@media only screen and (max-width: 768px)"],
					minWidth: "100%",
				},
			}),
			option: (styles, { isDisabled, isSelected }) => {
			  return {
				...styles,
				backgroundColor: isDisabled 
					? 'red' 
					: isSelected
					? '#CCE7E5'
					: '#fff',
				color: '#181818',
				fontSize: '1rem',
				cursor: isDisabled ? 'not-allowed' : 'default',
				padding: '0.625rem 1rem',
				"&:hover": {
					backgroundColor: "#daedeb"
				}
			  };
			},
			indicatorSeparator: styles => ({ 
				...styles, 
				display: 'none',
			}),
			dropdownIndicator: styles => ({ 
				...styles, 
				color: '#181818',
			}),
			menu: styles => ({ 
				...styles, 
				paddingTop: '0',
				paddingBottom: '0',
				margin: '0',
				borderRadius: '0.25rem',
			}),
			menuList: styles => ({ 
				...styles,
				padding: '0',
				margin: '0',
				height: '100%',
				borderColor: '#6D6D6D',
				borderRadius: '0.25rem',
				paddingTop: '0',
				paddingBottom: '0',
				fontSize: '1rem',
			}),
			placeholder: styles => ({ 
				...styles,
				fontSize: '1rem',
			}),
			selectedValue: styles => ({ 
				...styles,
				fontSize: '1rem',
			}),
		};

		return (
			<div className="search-results__sortby js-form-type-select">
				<label htmlFor="sort-by">Sort results by</label>
				<Select
					onChange={this.onSelect}
					options={this.options}
					styles={customDropdownStyles}
				/>
			</div>
		);
	}}


FederatedSortMenu.propTypes = {
	bootstrapCss: PropTypes.bool,
	onChange: PropTypes.func,
	sortFields: PropTypes.array,
	defaultSort: PropTypes.string
};

export default FederatedSortMenu;
